// extracted by mini-css-extract-plugin
module.exports = {"LoadingPlaceholderParent":"my_a","LoadingPlaceholder":"my_b pz_h","loading-placeholder":"my_c"};